import { PostalAreas } from "us.common/constants";
import { IAPIAction } from "us.common/interfaces";

const {
  SAVE_POSTAL_AREA,
  SAVE_POSTAL_AREA_SUCCESS,
  SAVE_POSTAL_AREA_FAIL,
  GET_POSTAL_AREAS,
  GET_POSTAL_AREAS_SUCCESS,
  GET_POSTAL_AREAS_FAIL,
  SET_POSTAL_AREA_DRAWER,
  DELETE_POSTAL_AREA,
  DELETE_POSTAL_AREA_SUCCESS,
  DELETE_POSTAL_AREA_FAIL,
} = PostalAreas;

export const postalAreas: Readonly<IAPIAction> = {
  postalAreas: {
    get: (data) => ({
      type: GET_POSTAL_AREAS,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: GET_POSTAL_AREAS_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_POSTAL_AREAS_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  postalArea: {
    save: (data) => ({
      type: SAVE_POSTAL_AREA,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: SAVE_POSTAL_AREA_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: SAVE_POSTAL_AREA_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
    openDrawer: (data) => ({
      type: SET_POSTAL_AREA_DRAWER,
      payload: {
        data,
        isLoading: true,
      },
    }),
  },
  deletePostalArea: {
    delete: (data) => ({
      type: DELETE_POSTAL_AREA,
      payload: {
        data: data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: DELETE_POSTAL_AREA_SUCCESS,
      payload: {
        data: data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: DELETE_POSTAL_AREA_FAIL,
      payload: {
        error: error,
        isLoading: false,
      },
    }),
  },
};
